import React, { useState, useEffect, useContext } from "react";
import Button from "../Button";
import NavItem from "./NavItem";
import navItemsList from "./NavItemList";
import uuid from "react-uuid";
import { hooks as mHooks } from "../../wallet/metamask";
import { hooks as wHooks } from "../../wallet/walletconnect";
import AppContext from "../../AppContext";
import WalletAddress from './WalletAddress';

const Navbar = ({ isModalOpen, setIsModalOpen, setWalletChoice }) => {
	const state = useContext(AppContext);

	const [mobileMenu, setMobileMenu] = useState(false);
	const [walletAddress, setWalletAddress] = useState("");

	const { useAccounts } =
		state.walletChoice === "metamask"
			? mHooks
			: state.walletChoice === "walletconnect"
			? wHooks
			: mHooks;
	const accounts = useAccounts();

	useEffect(() => {
		if (accounts) {
			changeWalletOnConnect(accounts[0]);
		}
	}, [accounts]);

	const changeWalletOnConnect = (walletAddr) => {
		setWalletAddress(walletAddr);
	};

	return (
		<>
			<nav className="mx-auto w-11/12 lg:w-2/3 flex justify-between items-center bg-black text-white m-4 my-8 p-4 rounded-md  drop-shadow-xl">
				<div className="text-3xl font-bold gradient-w-bg">
					<a href="/">Mōmoku</a>
				</div>
				<div className={`hidden lg:flex`}>
					{navItemsList.map((navItem) => {
						const { text, href } = navItem;
						return (
							<div key={uuid()}>
								<NavItem text={text} href={href} />
							</div>
						);
					})}
				</div>
				{walletAddress ? (
					<WalletAddress
						walletAddress={walletAddress}
						setWalletChoice={setWalletChoice}
						classes={`hidden lg:flex`}
					/>
				) : (
					<Button
						text="Connect Wallet"
						classes={`hidden lg:flex`}
						onClick={() => {
							setIsModalOpen(!isModalOpen);
						}}
					/>
				)}
				{/* menu button */}
				<div
					className="lg:hidden cursor-pointer"
					onClick={() => {
						setMobileMenu(!mobileMenu);
					}}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M4 6h16M4 12h16M4 18h16"
						/>
					</svg>
				</div>
			</nav>
			{mobileMenu ? (
				<div className="w-11/12 bg-black text-white rounded-md flex-col place-items-center p-4 gap-y-4 mx-auto">
					<div className="flex flex-col gap-y-4 place-items-center">
						{navItemsList.map((navItem) => {
							const { text, href } = navItem;
							return (
								<div key={uuid()}>
									<NavItem text={text} href={href} />
								</div>
							);
						})}
					</div>
					<div className="w-full flex">
						{walletAddress ? (
							<WalletAddress
								walletAddress={walletAddress}
								setWalletChoice
								classes={`my-2 m-auto`}
							/>
						) : (
							<Button
								text="Connect Wallet"
								classes="my-2 m-auto"
								onClick={() => setIsModalOpen(!isModalOpen)}
							/>
						)}
					</div>
				</div>
			) : (
				""
			)}
		</>
	);
};

export default Navbar;
